




import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";

import State from "@/state";

import Question, { ButtonData } from "./Question.vue";
import ResponseMixin from "./responseMixin";

@Component({ components: { Question } })
export default class Start extends mixins(ResponseMixin) {
  private hasBackButton = false;

  private buttons: ButtonData[] = [
    { text: "stateMachine.start.buttons.patient", response: State.Patient },
    { text: "stateMachine.start.buttons.visitor", response: State.Visitor },
    { text: "stateMachine.start.buttons.companion", response: State.Companion },
  ];

  private text = "stateMachine.start.text";
}
